module.exports = __webpack_public_path__ + "static/media/RCImg8.44c15c45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RCImg8.jpg
// module id = 1169
// module chunks = 0